import React from 'react';
import chatIcon from '@/assets/icons/chat.svg';
import { openChat } from '@/utils/linksUtils';
import { useSelectedStudent } from '@context/SelectedStudentContext';
import { useSchool } from '@context/SchoolContext';
import { ButtonSkeleton } from '@components/Skeletons/Skeletons';
import { useSkeletonLoader } from '@/hooks/useSkeletonLoader/useSkeletonLoader';

interface ChatButtonProps {
  identityId: string | null | undefined;
}

const ChatButton: React.FC<ChatButtonProps> = ({ identityId }) => {
  const handleChat = () => {
    openChat(identityId);
  };

  const { selectedStudent } = useSelectedStudent();
  const { data: schoolData, error: schoolError } = useSchool();

  const showSkeleton = useSkeletonLoader({
    schoolData,
    schoolError,
    selectedStudent,
    retryDelay: 3000,
    initialDelay: 2000,
    maxRetries: 2,
  });

  return (
    <>
      {showSkeleton ? (
        <div className="floating-chat-btn btn-skeleton">
          <ButtonSkeleton />
        </div>
      ) : (
        <button
          className="floating-chat-btn"
          aria-label="Chat with us"
          onClick={handleChat}
        >
          <img src={chatIcon} alt="Chat" className="chat-icon" />
          <span className="chat-label">Support</span>
        </button>
      )}
    </>
  );
};

export default ChatButton;
